import React from 'react';
import { Container } from "react-bootstrap";
import PdfGeneratorForm from "../PdfGeneratorForm";

/**
 * メインコンポーネントです。
 * @returns {JSX.Element} - JSX要素
 */
const Main: React.FC = () => {
  return (
    <main>
      <Container className="bg-white rounded-3 py-4 px-lg-5">
        <PdfGeneratorForm />
      </Container>
    </main>
  );
}

export default Main;